const indexItems = [
  { title: '动作片大全', desc: '热血燃爆的动作巨制合集', count: '560+部' },
  { title: '喜剧片精选', desc: '开怀大笑的解压神片', count: '420+部' },
  { title: '悬疑片剧场', desc: '层层反转的烧脑佳作', count: '380+部' },
  { title: '爱情片专场', desc: '温馨动人的浪漫故事', count: '450+部' },
  { title: '科幻片视界', desc: '脑洞大开的视觉盛宴', count: '310+部' },
  { title: '纪录片天地', desc: '真实世界的精彩记录', count: '280+部' },
  { title: '动画电影院', desc: '全年龄段的动画精品', count: '350+部' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            主题索引
          </h2>
          <p className="text-foreground-500 text-sm">按类型快速找到你想要的91电影免费资源</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 max-w-6xl mx-auto">
          {indexItems.map((item, idx) => (
            <a
              key={idx}
              href="#media"
              className="bg-background-50 rounded-xl p-6 hover:bg-background-200/70 transition-colors cursor-pointer group block"
            >
              <div className="flex items-center justify-between mb-3">
                <h3 className="text-base font-heading text-foreground-950 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <span className="text-xs text-primary-500 whitespace-nowrap">{item.count}</span>
              </div>
              <p className="text-sm text-foreground-600">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}